export function initQuotePullout() {
    if (window.acf) {
        window.acf.addAction(
            'render_block_preview/type=quote-pullout',
            quotePullout
        );
    }
}

export function quotePullout() {
    setupPostcodeLookup();
}

function setupPostcodeLookup() {
    var quotePullout = document.querySelector('.quote-pullout');
    if(quotePullout) {
        var postcodeInput = quotePullout.querySelector('input[name=block-quote-postcode]');
        new PostcodeLookup(postcodeInput);
    }
}

function debounce(func, wait, immediate) {
    var timeout;

    return function executedFunction() {
        var context = this;
        var args = arguments;

        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait);

        if (callNow) func.apply(context, args);
    };
};

class PostcodeLookup {
    constructor(input) {
        this.input = input;
        this.outcode = '';
        this.locations = window.locations;
        this.defaultDetails = window.defaultDetails;
        this.closestLocation = {};

        if(input) {
            this.input.addEventListener('keyup', (e) => {
                debouncedInputEvent(e);
            });
    
            const debouncedInputEvent = debounce(e => {
                this.onInput(e);
            }, 800);
        }

        this.resetClosestLocation();
    }

    onInput(e) {
        const postcode = e.target.value.toUpperCase();

        /* tests to see if string is in correct UK style postcode: AL1 1AB, BM1 5YZ etc. */
        function isValidPostcode(p) {
            var postcodeRegEx = /[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}/i;
            return postcodeRegEx.test(p);
        }

        /* formats a VALID postcode nicely: AB120XY -> AB1 0XY */
        function formatPostcode(p) {
            var postcodeRegEx = /(^[A-Z]{1,2}[0-9]{1,2})([0-9][A-Z]{2}$)/i;
            return p.replace(postcodeRegEx, '$1 $2');
        }

        if (isValidPostcode(postcode)) {
            const formatted = formatPostcode(postcode);
            this.outcode = formatted.split(' ')[0];
        } else {
            this.outcode = postcode.trim().split(' ')[0];
        }

        if (this.outcode.length) {
            this.search();
        } else {
            this.resetClosestLocation();
        }

    }

    search() {
        this.getClosestLocation();
        this.setClosestLocation();
    }

    getClosestLocation() {
        const match = this.locations.filter(location => {
            const postcodes = location.postcodes;
            var hasMatch = postcodes.some(postcode => new RegExp(this.outcode).test(postcode));
            if (hasMatch) {
                return location;
            }
        });

        if (match && match.length) {
            this.closestLocation = match[0];
        } else {
            this.closestLocation = this.getDefaultLocation();
        }
    }

    getDefaultLocation() {
        return this.locations.filter(l => l.name === 'Slough')[0];
    }

    setClosestLocation() {
        var postcodeResult = document.querySelector('.quote-pullout .depot');
        var telephoneResult = document.querySelector('.quote-pullout .telephone');
        var emailResult = document.querySelector('.quote-pullout .email');
        var toEmail = document.querySelector('input[name="block-quote-to-email"]');
        if(postcodeResult) postcodeResult.innerHTML = this.closestLocation.name;
        telephoneResult.innerHTML = this.closestLocation.tel;
        emailResult.innerHTML = this.closestLocation.send_to;
        toEmail.value = this.closestLocation.send_to;
    }

    resetClosestLocation() {
        var postcodeResult = document.querySelector('.quote-pullout .depot');
        var telephoneResult = document.querySelector('.quote-pullout .telephone');
        var emailResult = document.querySelector('.quote-pullout .email');
        var toEmail = document.querySelector('input[name="block-quote-to-email"]');
        var defaultLocation = this.getDefaultLocation();
        if(postcodeResult) postcodeResult.innerHTML = ''
        telephoneResult.innerHTML = this.defaultDetails.telephone ? this.defaultDetails.telephone : defaultLocation.tel;
        emailResult.innerHTML = this.defaultDetails.email ? this.defaultDetails.email : defaultLocation.send_to;
        toEmail.value = this.defaultDetails.email ? this.defaultDetails.email : defaultLocation.send_to;
    }
}